import styles from './Home.module.css'
import {Layout} from 'antd';
import GameHeader from "../components/GameHeader";
import PlayersList from "../components/PlayersList";
import Title from "antd/lib/typography/Title";
import ResultsLayout from "../components/ResultsLayout";
import {useEffect, useState} from "react";
import {ParamsDoc, PlayerDoc} from "../firebase/firestoreTypes";
import {useFirestore, useFirestoreCollectionData, useFirestoreDocData, useUser} from "reactfire";
import FinalResultsLayout from "../components/FinalResultsLayout";
import ChatWidget from "../components/ChatWidget";

export default function Results({code}: { code: string }) {

    const {Content, Footer, Sider} = Layout
    const [currentPlayer, setCurrentPlayer] = useState<PlayerDoc>();
    const gameCollection = useFirestore().collection(code)
    const playerDocs = useFirestoreCollectionData<PlayerDoc>(
        gameCollection.where("isPlayer", "==", true)
    );
    const gameParams = useFirestoreDocData<ParamsDoc>(gameCollection.doc("params"));
    const user = useUser();
    const isAdmin = user.data?.uid === gameParams.data?.createdBy;
    useEffect(() => {
        // Set current player state if it changes
        const player = playerDocs.data?.find(value => value.userId === user.data?.uid);
        setCurrentPlayer(player);
    }, [playerDocs, user]);


    return (
        <Layout className={styles.layout}>
            <GameHeader isLobby={false}
                        title={gameParams.data?.name}
                        currentMove={gameParams.data?.move}
                        totalMoves={gameParams.data?.totalMoves}/>
            <Layout>
                <Sider width={300} className={styles.sider}>
                    <Title level={3}>Partijos</Title>
                    <PlayersList players={playerDocs.data ?? []} currentPlayer={user.data?.uid} showResults={true}/>
                </Sider>
                <Layout>
                    <Content style={{padding: '50px 50px 0 25px', height: "100%"}}>
                        <div className={styles.content} style={{height: "100%"}}>
                            { gameParams.data?.move === gameParams.data?.totalMoves ?
                                <FinalResultsLayout players={playerDocs.data ?? []}
                                                    currentPlayer={currentPlayer}
                                                    isAdmin={isAdmin}
                                                    code={code}
                                                    nominations={gameParams.data?.nominations ?? []}/>
                                                    :
                                <ResultsLayout players={playerDocs.data ?? []}
                                               currentPlayer={currentPlayer}
                                               isAdmin={isAdmin}
                                               code={code}/>
                            }
                        </div>
                    </Content>
                </Layout>
            </Layout>
            <Footer style={{textAlign: 'center'}}>© Electo 2024, Jaunųjų konservatorių lygos (JKL) autorinė nuosavybė.</Footer>
            <ChatWidget code={code} currentPlayer={currentPlayer}/>
        </Layout>
    )
}
